export const SIXT_CODE = 'SX';
